
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/antara/api/custom",
      function () {
        return require("private-next-pages/en/docs/antara/api/custom/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/antara/api/custom"])
      });
    }
  